/* eslint-disable no-redeclare */
import React from 'react'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { sh, compose, ReduxWrapper } from 'common-data/datahelpers'
import { FAIcon } from './FAIcon'
import { FileImg } from './FileImg'
import styles from './FAIconPicture.less'
import Tooltip from 'rc-tooltip'
// import _ from 'common-tools/LodashHelper'
import clsx from 'clsx'

class FAIconPicturePlain extends React.Component {
  static propTypes = buildPropTypes([
    sh.SessionToken
  ], {
    icon: pt.string,
    pictureKey: pt.string,
    color: pt.string,
    size: pt.string,
    heightWidth: pt.number
  })

  static defaultProps = {
    color: 'purple',
    icon: 'user',
    size: '24px',
    heightWidth: 80
  }

  render () {
    const { pictureKey, icon, size, SessionToken, heightWidth, color, className, placement, overlayClassName, htmlToolTip, toolTip, name, noStyles = false } = this.props

    if (noStyles === true) {
      var ret = pictureKey
        ? <FileImg className={className} height={heightWidth} style={{ maxHeight: `${heightWidth + 10}px`, maxWidth: `${heightWidth + 10}px` }} pictureKey={pictureKey} SessionToken={SessionToken} />
        : <FAIcon name={name || icon} size={size} color={color} type='d'/>
    } else {
      var ret = <div className={clsx(styles.root, className, 'faiconpicture')}>
        <div style={{ height: `${heightWidth}px`, width: `${heightWidth}px`, borderRadius: `${heightWidth}px` }} className={clsx('pictureWrapper')}>
          {pictureKey
            ? <FileImg height={heightWidth} style={{ maxHeight: `${heightWidth + 10}px`, maxWidth: `${heightWidth + 10}px` }} pictureKey={pictureKey} SessionToken={SessionToken} />
            : <FAIcon name={name || icon} size={size} color={color} type='d'/>
          }
        </div>
      </div>
    }

    if (toolTip) {
      return (
        <Tooltip mouseEnterDelay={0.5} placement={placement} overlayClassName={`${overlayClassName || ''} ${color || ''}`} overlay={htmlToolTip ? <span dangerouslySetInnerHTML={{ __html: toolTip }}></span> : toolTip}>
          {ret}
        </Tooltip>
      )
    } else {
      return ret
    }
  }
}

export const FAIconPicture = compose(
  ReduxWrapper([
    sh.SessionToken
  ])
)(FAIconPicturePlain)
